$(document).ready(function () {

    $(document).on('click', '.js__filter_checbox', function () {
        submitFilters();
    });

    $(document).on('click', '.js__sorting_good', function () {
        submitFilters();
    });

    $(document).on('click', '.js__sort_by_good', function () {
        submitFilters();
    });

    $(document).on('click', '.js__filter_brand', function () {
        submitFilters();
    });

    $(document).on('click', '.js__remove_filter', function () {
        $('.js__filter_checbox, .js__sorting_good, .js__filter_brand').prop('checked', false);
        submitFilters(true);
    });

    $(document).on('click', '.js__remove_char', function () {
        const btn = $(this);
        const val = btn.attr('data-val');

        $(`#${val}`).trigger('click');
    })

    function submitFilters(isRemove = false) {
        var array = {};
        // array.brands = [];
        // array.series = [];
        // array.min_price = '';
        // array.max_price = '';
        array.vals = [];
        array.sorting = [];
        array.sort_by = [];
        array.brands = [];

        $(".js__filter_checbox").each(function () {
            if ($(this).is(":checked")) {
                array.vals.push($(this).val());
            }
        });

        $(".js__sorting_good").each(function () {
            if ($(this).is(":checked")) {
                array.sorting.push($(this).val());
            }
        });

        $(".js__sort_by_good").each(function () {
            if ($(this).is(":checked") && $(this).val() != 'default') {
                array.sort_by.push($(this).val());
            }
        });

        $(".js__filter_brand").each(function () {
            if ($(this).is(":checked")) {
                array.brands.push($(this).val());
            }
        });

        // var selected_min_price = parseInt($('#input_min_price').val()),
        //     start_min_price = parseInt($('#input_min_price').attr('data-start-min')),
        //     selected_max_price = parseInt($('#input_max_price').val()),
        //     start_max_price = parseInt($('#input_max_price').attr('data-start-max'));

        // if (!isNaN(selected_max_price) && selected_max_price != start_max_price) {
        //     array.max_price = selected_max_price;
        // } else {
        //     if (!isNaN(selected_min_price) && selected_min_price != start_min_price) {
        //         array.max_price = start_max_price;
        //     } else {
        //         delete array.max_price;
        //     }
        // }
        // if (!isNaN(selected_min_price) && selected_min_price != start_min_price) {
        //     array.min_price = selected_min_price;
        // } else {
        //     delete array.min_price;
        // }

        if (array.vals.length < 1) {
            delete array.vals;
        }

        if (array.sorting.length < 1) {
            delete array.sorting;
        }

        if (array.sort_by.length < 1) {
            delete array.sort_by;
        }

        if (array.brands.length < 1) {
            delete array.brands;
        }


        filters = JSON.stringify(array);


        filters = filters.replace(/}/g, 'ru').replace(/{/g, 'lu').replace(/"/g, 'kv').replace(/:/g, 'dv').replace(/,/g,
            'zp').replace(/]/g, 'rk').replace(/\[/g, 'lk');

        let url = main_url;

        if (!isRemove) {
            if (filters != 'luru') {
                url = url + "?filters=" + filters;
            } else {
                filters = "";
            }
        }

        history.pushState({}, '', url);

        $.post(requests.loadGoods, {
            'take': take,
            'skip': 0,
            'cat_id': cat_id,
            'brand_id': typeof brand_id !== 'undefined' ? brand_id : undefined,
            'is_new':  typeof is_new !== 'undefined' ? is_new : undefined,
            'filters': filters,
            "lang": lang,
        }, function (data) {
            if (data.status == 'success') {
                $('.js__pagination_load').empty().append(data.html_pagination);
                $('.js__goood_load').empty().append(data.html);

                page = 1;
                total = data.total_count;

                goodListNameHeight();
                paginationNum(page, +take, false);

                loadFilters(filters);
            }
        });
    }
})